import gql from 'graphql-tag';

export const WelcomeMessagesQuery = gql`
	query WelcomeMessagesQuery {
		spaViewContext {
			welcomeMessageEditUrl
			welcomeMessageHtml
			resourceKeys
			resourceContexts
			showWelcomeMessageEditHint
			showEditButton
		}
	}
`;
